import React, { Fragment, useState, useEffect } from 'react';
import { Table, Container, Row, Col, Input, Spinner, Button, FormGroup, Label, Progress, FormFeedback, FormText } from "reactstrap";
import Thumb from '../../../assets/thumb-ok.svg';
import '../../Steps/steps.scss';
import { useNavigate } from 'react-router-dom';

function Sprint2Step4() {
	const navigate = useNavigate();

    return (
    	<Fragment>
	        <nav id="topbar">
	    		<Container className="builde-cont">
			    	<Row>
		    			<Col xs={{size: 12}}>
		    				<div className="cont-topbar">
		    					<Button className="btn-back" onClick={() => navigate(-1)}></Button>
		    				</div>
		    			</Col>
			    	</Row>
		    	</Container>
	    	</nav>
	    	<section id="progress-bar">
	    		<Container className="builde-cont">
			    	<Row>
		    			<Col xs={{size: 12}}>
	    					<Progress value={75}></Progress>
		    			</Col>
			    	</Row>
		    	</Container>
	    	</section>
	    	<form className="m-t-20 form-base-dis">
	    		<Container className="builde-cont">
			    	<Row>
		    			<Col xs={{size: 12}}>
		    				<h1 className="m-b-30">What's your deadline?</h1>

							<input type="checkbox" id="toggle" className="toggle-checkbox" />
							<label htmlFor="toggle" className='toggle-container'>
							  <div>Complete in</div>   
							  <div>Flexible</div>
							</label>
		    			</Col>
			    	</Row>

			    	<Row>
		    			<Col xs={{size: 12}}>
		    				<div className="circle-selector ">
		    					<div className="background-selector"></div>
		    					<div className="background-bottom-selector"></div>
		    					<div className="background-top-selector"></div>
		    					<div className="fill"></div>
		    					<div className="circle-selector-cont">
		    						<div className="text">
		    							<span className="number">3</span>
		    							<span className="day">days</span>
		    						</div>
		    						<div className="dots dots1"></div>
		    						<div className="dots dots2"></div>
		    						<div className="dots dots3"></div>
		    						<div className="dots dots4"></div>
		    						<div className="dots dots5"></div>
		    						<div className="dots dots6"></div>
		    						<div className="thumb-up"></div>
		    					</div>
			    			</div>
		    			</Col>
			    	</Row>

			    	<Row>
		    			<Col xs={{size: 12}}>
		    				<div className="d-grid gap-2 m-t-40">
			    				<Button color="primary" size="lg">Continue</Button>
			    			</div>
		    			</Col>
			    	</Row>
			    	
		    	</Container>
	    	</form>
    	</Fragment>
    );
}

export default Sprint2Step4;